/**
 * @generated SignedSource<<dbb4be71e73fd06e3e95cb509e5454c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetClubPhoneNumberFragment_club$data = {
  readonly phoneNumber: {
    readonly formattedNumber: string;
  } | null | undefined;
  readonly " $fragmentType": "useGetClubPhoneNumberFragment_club";
};
export type useGetClubPhoneNumberFragment_club$key = {
  readonly " $data"?: useGetClubPhoneNumberFragment_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetClubPhoneNumberFragment_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetClubPhoneNumberFragment_club",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhoneNumber",
      "kind": "LinkedField",
      "name": "phoneNumber",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formattedNumber",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "65c588a1dcf9a10927d84418d6c56cf4";

export default node;
